module.exports = __webpack_public_path__ + "img/kjsy_thumbnail.a95f6619.jpg";